import React, { useState, useMemo } from 'react';
import { partners, partnerCategories } from '../data/partners';
import SEO from '../components/SEO';
import PartnersHero from '../components/partners/PartnersHero';
import BecomePartnerCTA from '../components/partners/BecomePartnerCTA';
import FeaturedPartnerCard from '../components/partners/FeaturedPartnerCard';
import PartnerCard from '../components/partners/PartnerCard';
import AdvertiseCTASection from '../components/partners/AdvertiseCTASection';
import PublishedBy from '../components/partners/PublishedBy';

const PartnersPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const featuredPartners = useMemo(() => partners.filter((p) => p.featured), []);

  const filteredPartners = useMemo(
    () =>
      selectedCategory === 'All'
        ? partners
        : partners.filter((p) => p.category === selectedCategory),
    [selectedCategory],
  );

  return (
    <div className="min-h-screen bg-[#FAF9F7]">
      <SEO
        title="Our Partners"
        description="Discover Malta's finest wedding professionals, photographers, venues, florists, caterers, and more. Browse our curated directory of trusted wedding vendors."
      />
      <PartnersHero />
      <BecomePartnerCTA />

      {/* Featured Partners */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#DE92A9] text-xs tracking-[0.3em] uppercase mb-4">
              Spring & Summer 2026 Issue
            </p>
            <h2
              className="text-3xl md:text-4xl text-[#2C2C2C] mb-4"
              style={{ fontFamily: '"Playfair Display", serif' }}
            >
              Featured Partners
            </h2>
            <p className="text-[#6B4E37] max-w-2xl mx-auto">
              The trusted names featured in our current Candyland Romance issue.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {featuredPartners.map((partner) => (
              <FeaturedPartnerCard key={partner.id} partner={partner} />
            ))}
          </div>
        </div>
      </section>

      {/* All Partners with Filter */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2
              className="text-3xl md:text-4xl text-[#2C2C2C] mb-4"
              style={{ fontFamily: '"Playfair Display", serif' }}
            >
              All Wedding Vendors
            </h2>
            <p className="text-[#6B4E37] max-w-2xl mx-auto mb-8">
              Browse our complete directory of trusted wedding professionals across Malta.
            </p>

            <div className="flex flex-wrap justify-center gap-2 mb-8">
              {partnerCategories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 text-xs tracking-wider rounded-full transition-all ${
                    selectedCategory === category
                      ? 'bg-[#DE92A9] text-white'
                      : 'bg-white text-[#6B4E37] hover:bg-[#F5F3F0] border border-[#E5E0DA]'
                  }`}
                  data-testid={`category-filter-${category.toLowerCase()}`}
                >
                  {category.toUpperCase()}
                </button>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredPartners.map((partner) => (
              <PartnerCard key={partner.id} partner={partner} />
            ))}
          </div>
        </div>
      </section>

      <AdvertiseCTASection />
      <PublishedBy />
    </div>
  );
};

export default PartnersPage;
